module.exports = __webpack_public_path__ + "img/notes.06e19c34.png";